import assistantsFormModel from './assistantsFormModel';

const {
    formField: {
        name,
        description,
        service_id,
        systemPrompt,
        welcomeMessage,
        temperature,
        topP,
        maxTokens,
        avatar,
        icon,
        color,
        visibility,
        isPublic,
        allowHistory,
        allowImages,
        allowAudio,
        allowFileUpload,
        maxMessagesPerDay,
        maxContextMessages,
        assignedSkills
    }
} = assistantsFormModel;

export default {
    [name.name]: '',
    [description.name]: '',
    [service_id.name]: undefined,
    [systemPrompt.name]: '',
    [welcomeMessage.name]: '',
    [temperature.name]: '',
    [topP.name]: '',
    [maxTokens.name]: '',
    [avatar.name]: '',
    [icon.name]: '',
    [color.name]: '',
    [visibility.name]: { value: 'private', label: 'Privado' },
    [isPublic.name]: false,
    [allowHistory.name]: true,
    [allowImages.name]: false,
    [allowAudio.name]: false,
    [allowFileUpload.name]: false,
    [maxMessagesPerDay.name]: '',
    [maxContextMessages.name]: '',
    [assignedSkills.name]: {}
};
